import { useEffect, useState } from 'react';

export const useLoadScript = (url: string, props?: Dict): boolean => {
  const [loaded, setLoaded] = useState(
    document.querySelectorAll(`script[src="${url}"]`).length > 0,
  );

  useEffect(() => {
    if (loaded) return;
    const script = document.createElement('script');
    script.src = url;
    if (props) {
      const keys = Object.keys(props);
      for (let i = 0; i < keys.length; i++) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (script as any)[keys[i]] = props[keys[i]] || '';
      }
    }
    script.onload = () => setLoaded(true);
    document.body.appendChild(script);
  }, [loaded, props, url]);

  return loaded;
};
